export default function StorySkeleton() {
  return (
    <div className="flex items-stretch bg-[var(--sc-surface)] border border-[var(--sc-border)] rounded-[var(--sc-radius-lg)] overflow-hidden animate-pulse">
      <div className="w-1 bg-[var(--sc-border)] flex-shrink-0" />
      <div className="flex flex-1 items-center gap-6 px-5 py-4">
        <div className="flex-1">
          <div className="h-4 bg-[var(--sc-border)] rounded w-2/5 mb-2" />
          <div className="flex gap-2">
            <div className="h-3 bg-[var(--sc-border)] rounded w-20" />
            <div className="h-3 bg-[var(--sc-border)] rounded w-24" />
          </div>
        </div>
        <div className="flex items-center gap-4 flex-shrink-0">
          <div className="h-8 w-8 bg-[var(--sc-border)] rounded" />
          <div className="w-px h-8 bg-[var(--sc-border)]" />
          <div className="h-8 w-8 bg-[var(--sc-border)] rounded" />
        </div>
      </div>
    </div>
  );
}
